import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Collapse } from "antd";
import LoadingContent from '../../component/loading/LoadingContent'
import styled from "styled-components";

import LineGraph from "./LineGraph";
import FormLineChartPanel from './FormLineChartPanel'
import TableMgtParams from './TableMgtParams'
import actions from "../../redux/actions";

const Section = styled.section`
    height: 100%;
    
    & > .container{ 
        height: 44.5%;
        .row-panel{ 
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-bottom: 15px;
          .row-panel-left{
            width: 100%;
              margin-bottom: 15px;
            & > * {
              width: 100%;
            }
          } 
          }
          .row-panel-right{
            width: 100%;
            & > .table {
            width: 100%;
          }
          }

    }

`;

export default function compareGraph(props) {

  const [content, setContent] = useState(false)
  const dispatch = useDispatch()
  const [formSearch, setFormSearch] = useState(null);

  useEffect(() => {
    dispatch(actions.master.setPath("/compare-graph"))
    const init = async () => {
      setContent(true)
    }

    init()

  }, [dispatch, formSearch])

  return (
    <Section className={"section-station" + (props.className ? props.className : "")}>
      <div className="container">
        {!content ? <LoadingContent />
          :
          <>
            <div className="page-title">
              <img src='/image/dashboard.png' alt="icon-dashboard" />
              <span>กราฟเปรียบเทียบข้อมูล</span>
            </div>
            <div className="row-panel">
              <div className="row-panel-left">
                <FormLineChartPanel setFormSearch={setFormSearch}/>
              </div>
              <div className="row-panel-right">
                <TableMgtParams />
              </div>
            </div>
            <div className="row-graph">
              <LineGraph formSearch={formSearch}/>
            </div>
          </>
        }
      </div>
    </Section>
  )
}
